import LoginLayout from "./login-layout";
import StudentDashboardLayout from "./student-dashboard-layout";

export default {
  StudentDashboardLayout,
  LoginLayout,
};
